// extracted by mini-css-extract-plugin
module.exports = {"root":"trackless-slide_root__2kUz5","item":"trackless-slide_item__4-sVU"};